module.exports = __webpack_public_path__ + "static/media/hackcraft.3bcb221b.png";